<div>
    <ul>
        <li>
            <a routerLink="home" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Datasets</a>
        </li>
        <li>
            <a routerLink="listFormat" routerLinkActive="active">List (Format)</a>
        </li>
        <li>
            <a routerLink="flowChart" routerLinkActive="active">Flowchart</a>
        </li>

    </ul>

</div>
